import React from 'react'

export class RestartConversationContainer extends React.Component {

  componentDidMount() {
    window.addEventListener('message', this.handleLanguageChange);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleLanguageChange);
  }

  handleLanguageChange = (event) => {
    if (event?.data?.payload?.type === "proactive-trigger") {
      const langHtml = event?.data?.payload?.payload?.language
      const previousLang = event?.data?.payload?.payload?.changeLang

      if (langHtml != previousLang){
        if (this?.props?.store?.currentConversation) {
          this.props.store.clearMessages();
        }
      }
    }
  }

  render() {
    return null;
  }
}
